// libs
import NFA from 'shared/helpers/analytics/NFAnalytics';

import { PDP_EVENTS } from 'shared/helpers/analytics/constants/pdpEvents';

export const onReferSizeGuideClickTracking = () => {
  NFA.track({
    event: PDP_EVENTS.SIZE_CHART_CLICK,
  });
};

export const trackSizeGuideChartClosed = () => {
  NFA.track({
    event: PDP_EVENTS.SIZE_CHART_CLOSED,
  });
};

export const trackReviewViewed = () => {
  NFA.track({
    event: PDP_EVENTS.REVIEWS_VIEWED,
  });
};
